<div class="popup-container">
  <div *ngIf="isLoading() === false" class="container">
    <header class="header" [class.header-stats]="canViewInfluencerStats() && showLeaderboard()">
      @if (canViewInfluencerStats() && showLeaderboard()) {
        <button aria-label="Back to sharing" class="centered-button back-button-icon small" (click)="toggleLeaderboard(false)">
          <mat-icon style="font-size: large">arrow_back</mat-icon>
        </button>
      }
      <div class="event-branding">
        <img src="{{ eventImageUrl() }}" alt="Event Logo" class="logo" />
        <h1>{{ eventName() }}</h1>
      </div>
      @if (sponsor(); as sponsor) {
        <a class="referral-sponsor" [href]="sponsor.url" target="_blank" rel="noopener noreferrer">
          <img [src]="sponsor.logo" [alt]="sponsor.name + ' logo'" />
          <span>Sponsored by: {{ sponsor.name }}</span>
        </a>
      }
    </header>
    <div class="content">
      @if (canViewInfluencerStats() && showLeaderboard()) {
        @defer (on immediate) {
          <app-influencer-stats (backToSharing)="toggleLeaderboard(false)"></app-influencer-stats>
        } @placeholder {
          <p role="status">Loading influencer stats…</p>
        } @error {
          <p role="alert">We could not load your stats. Please return to sharing and try again.</p>
          <button class="centered-button generic" (click)="toggleLeaderboard(false)">Back to sharing</button>
        }
      } @else {
        <section class="section-left">
          <div class="body-text">
            <h3 class="campaign-heading margin-top-0">
              <strong>{{ campaignTitle() }}</strong>
            </h3>

            <p class="preline">{{ campaignText() }}</p>
            <p *ngIf="useIncentive()" class="preline">
              <em>{{ incentiveText() }}</em>
              <span *ngIf="incentiveTCs().length > 0">
                <br />
                <br />
                <a href="{{ incentiveTCs() }}" target="_blank">Learn more</a>
              </span>
            </p>
            @if (usePersonalisation()) {
              <h3 class="margin-top-2"><strong>Enhance your post</strong></h3>
              <p>We'll get your name and profile pic from LinkedIn. Attract more attention by entering your job title and company name.</p>
              <div class="personalisation">
                <mat-form-field class="full-width">
                  <mat-label>Job title (optional)</mat-label>
                  <input [(ngModel)]="jobTitle" matInput maxlength="40" />
                </mat-form-field>
                <mat-form-field class="full-width">
                  <mat-label>Company (optional)</mat-label>
                  <input [(ngModel)]="company" matInput maxlength="40" />
                </mat-form-field>
              </div>
            }
            @if (enableLeaderboard()) {
              <p>
                <strong class="italics">{{ influencerMessage() }}</strong>
              </p>
            }
            <div class="primary-actions">
              <div class="button-container margin-bottom-1 primary-action-buttons">
                <button
                  class="centered-button linkedin"
                  [ngClass]="selectedNetwork().class"
                  [title]="getFriendlyTitle(selectedNetwork().name)"
                  [disabled]="selectedNetwork().name === 'LinkedIn' && linkedInSharing()"
                  [attr.aria-busy]="selectedNetwork().name === 'LinkedIn' && linkedInSharing()"
                  (click)="share(selectedNetwork().name)"
                >
                  <img [src]="selectedNetwork().icon" alt="Button icon" class="button-icon-large" [ngClass]="selectedNetwork().imgIcon" />
                  <span class="button-text">{{ buttonText() }}</span>
                </button>
                @if (canViewInfluencerStats()) {
                  <button class="centered-button generic" (click)="toggleLeaderboard(true)">
                    <mat-icon style="margin-bottom: 2px">bar_chart</mat-icon>&nbsp;View influencer stats
                  </button>
                }
              </div>
            </div>
            @if (linkedInShareError()) {
              <p role="alert">{{ linkedInShareError() }}</p>
            }
            <div *ngIf="filteredNetworks().length > 0">
              <p>Or select another network:</p>
              <div class="button-container">
                <ng-container *ngFor="let network of filteredNetworks()">
                  <button
                    class="centered-button generic"
                    [ngClass]="{ selected: network.selected }"
                    [title]="getFriendlyTitle(network.name)"
                    [disabled]="network.name === 'LinkedIn' && linkedInSharing()"
                    (click)="share(network.name).then()"
                  >
                    <img [src]="network.iconBw" [alt]="network.name + ' icon'" class="button-icon-large margin-bottom-0" />
                  </button>
                </ng-container>
              </div>
            </div>
            @if (sponsor(); as sponsor) {
              <section class="sponsor-feature">
                <p>A message from our sponsor:</p>
                <a class="sponsor-identity" [href]="sponsor.url" target="_blank" rel="noopener noreferrer">
                  <img [src]="sponsor.logo" [alt]="sponsor.name + ' logo'" />
                  <span>{{ sponsor.name }}</span>
                </a>
                <p class="preline">{{ sponsor.message }}</p>
                <a [href]="sponsor.url" target="_blank" rel="noopener noreferrer">Learn more</a>
              </section>
            }
          </div>
        </section>
        <section class="section-right">
          <p class="buzzwave-invitation-preview-top">Invitation preview</p>
          <div class="linkedin-preview-wrapper">
            <img class="image-preview-top" src="/assets/previewPostTop.png" alt="Image preview" />
            <p
              id="fullPostBody"
              class="preview-text-no-margin-top preline"
              [innerHTML]="selectedNetwork().name === 'Twitter' ? postBodyTwitterWithShortLinks() : postBodyWithShortLinks()"
            ></p>
            <img id="image-preview" class="image-preview" [src]="postImageUrl()" alt="Image preview" />
          </div>
          <p class="buzzwave-invitation-preview-bottom">Invitation preview</p>
        </section>
      }
    </div>
    <section class="section-centered" *ngIf="showBuzzwaveBranding()">
      <img src="/assets/buzzwave-logo.png" class="buzzwave-logo" alt="Buzzwave" />
      <div class="buzzwave-link-text">Powered by <a href="https://buzzwave.io" class="buzzwave-link" target="_blank">Buzzwave</a></div>
    </section>
  </div>
</div>
